import { create, w } from '@dojo/framework/core/vdom';
import { ChartBase } from './base-chart';
const factory = create({}).properties();
export const LineChart = factory(({ properties }) => {
    const { ariaLabel = 'line chart', size, data, drawComplete, legend, options, plugins, pluginCode, title, alternateText } = properties();
    const type = 'line';
    return w(ChartBase, {
        ariaLabel,
        alternateText,
        size,
        data,
        drawComplete,
        legend,
        options,
        plugins,
        pluginCode,
        title,
        type
    });
});
